import { useLanguage, useSEO } from "../context/LanguageContext";
import { PageHero, Reveal, Overline } from "../components/Kinetic";
import { SubmissionForm } from "../components/SubmissionForm";

const ContactPage = () => {
  const { t } = useLanguage();
  useSEO(t("contact.metaTitle"), t("contact.metaDesc"));
  const infoItems = t("contact.infoItems");

  const fields = [
    { name: "name", label: t("forms.name"), type: "text" },
    { name: "email", label: t("forms.email"), type: "email" },
    { name: "organization", label: t("forms.organization"), type: "text", required: false },
    { name: "subject", label: t("forms.subject"), type: "text" },
    { name: "message", label: t("forms.message"), type: "textarea" },
  ];

  return (
    <div data-testid="contact-page">
      <PageHero
        overline={t("contact.overline")}
        titleLines={t("contact.titleLines")}
        intro={t("contact.intro")}
        testid="contact"
      />

      <section className="py-24 md:py-32">
        <div className="mx-auto grid max-w-7xl gap-16 px-6 lg:grid-cols-5">
          <div className="lg:col-span-2">
            <Reveal y={16}>
              <Overline>{t("contact.infoTitle")}</Overline>
            </Reveal>
            <div className="mt-8">
              {infoItems.map((item) => (
                <Reveal key={item.label} y={12}>
                  <div className="border-b border-graphite/10 py-5">
                    <p className="overline-mono text-graphite-soft">{item.label}</p>
                    {item.value.includes("@") ? (
                      <a
                        href={`mailto:${item.value}`}
                        className="mt-2 inline-block text-base text-forest underline underline-offset-4 transition-colors hover:text-graphite"
                        data-testid="contact-email-link"
                      >
                        {item.value}
                      </a>
                    ) : (
                      <p className="mt-2 text-base text-graphite">{item.value}</p>
                    )}
                  </div>
                </Reveal>
              ))}
            </div>
            <Reveal delay={0.2}>
              <p className="mt-8 border-l-2 border-forest pl-5 text-sm leading-relaxed text-graphite-soft">
                {t("contact.emailNote")}
              </p>
            </Reveal>
          </div>
          <Reveal delay={0.1} className="lg:col-span-3">
            <div className="border border-graphite/10 bg-white p-8 md:p-12">
              <h2 className="font-display text-2xl md:text-3xl font-light tracking-tight text-graphite">
                {t("contact.formTitle")}
              </h2>
              <div className="mt-8">
                <SubmissionForm formType="contact" fields={fields} submitLabel={t("contact.formSubmit")} testid="contact" />
              </div>
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
};

export default ContactPage;
